<script>
	import configuration from '../configuration.json';
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId, isChatAssisted } from '../data/session.svelte.js';

	import { onMount } from 'svelte';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';
    import { normalizeTelephone } from '../helpers/phone.js';
    import { _, locale } from 'svelte-i18n';
    import { get } from 'svelte/store';

    import Section from '../components/Section.svelte';
    import Loader from '../components/Loader.svelte';

    async function createWaitlist() {
        try {
            const form = new FormData();
            form.append('session', currentSessionId);
            form.append('client', currentSession.client);
            form.append('salon', currentSession.salon);
            form.append('application', 'nl.salonhub.afspraak');
            form.append('assistant', isChatAssisted());
            form.append('date', currentSession.date);
            form.append('time', currentSession.time); // comma-separated string
            form.append('treatment', JSON.stringify({
                id: currentSession.treatment?.id,
                name: currentSession.treatment?.name,
                length: currentSession.treatment?.length,
            }));
            form.append('employee', JSON.stringify({
                id: currentSession.employee?.id || 0,
                name: currentSession.employee?.name || '',
            }));

            // Customer as JSON string
            const customer = JSON.stringify({
                firstname: currentSession.customer.firstname,
                lastname: currentSession.customer.lastname,
                email: currentSession.customer.email,
                telephone: normalizeTelephone(currentSession.customer.telephone)
            });
            form.append('customer', customer);

            const response = await fetch(`${configuration.endpoint}/OnlineAppointment.Remote.Waitlist/add`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${configuration.apikey}`,
                    'Accept-Language': get(locale)
                },
                body: form
            });

            /* Success! */

            if (response.ok) {
                const result = await response.json();

                currentSession.id = result.waitlist;
                currentSession.status = 'confirmed';

                replace('success');
                return;
            }
        } catch (error) {
        }

        /* All other errors */

        replace('error/failed');
    }

    async function createAppointment() {
        try {
            const url = new URL(`${configuration.endpoint}/OnlineAppointment.Remote.Appointments/create`);
            url.searchParams.append('client', currentSession.client);
            url.searchParams.append('salon', currentSession.salon);
            url.searchParams.append('session', currentSessionId);

            // Build the request body
            const body = {
                settings: {
                    application: 'nl.salonhub.afspraak',
                    assistant: isChatAssisted(),
                    guid: persistent.guid,
                    origin: currentSession.origin || '',
                    email: {
                        enabled: true,
                        urls: {
                            verify: `${window.location.origin}/{CLIENT}/{SALON}/verify?appointment={APPOINTMENT}&code={CODE}`
                        }
                    }
                },
                appointment: {
                    date: currentSession.date,
                    treatments: [
                        {
                            time: currentSession.time,
                            treatment: {
                                id: currentSession.treatment?.id,
                                name: currentSession.treatment?.name,
                                length: currentSession.treatment?.length,
                            },
                            employee: {
                                id: currentSession.employee?.id || 0,
                                name: currentSession.employee?.name || '',
                            },
                        }
                    ]
                },
                customer: {
                    name: {
                        firstname: currentSession.customer.firstname,
                        lastname: currentSession.customer.lastname
                    },
                    email: currentSession.customer.email,
                    telephone: normalizeTelephone(currentSession.customer.telephone)
                }
            };

            const response = await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${configuration.apikey}`,
                    'Content-Type': 'application/json',
                    'Accept-Language': get(locale)
                },
                body: JSON.stringify(body)
            });

            /* Success! */

            if (response.ok) {
                const result = await response.json();

                currentSession.id = result.appointment;
                currentSession.token = result.token;
                currentSession.status = result.status;

                if (result.status === 'verify') {
                    replace('verify');
                }
                else {
                    replace('success');
                }

                return;

            }

            /* Conflict */

            else if (response.status === 409) {
                replace('failure');
                return;
            }
        } catch (error) {
        }

        /* All other errors */

        replace('error/failed');
    }

    onMount(() => {
        if (currentSession.status === 'confirmed') {
            replace('success');
        }
        else if (currentSession.status === 'verify') {
            replace('verify');
        }
        else {
            setTimeout(() => {
                if (currentSession.type === 'waitlist') {
                    createWaitlist();
                } else {
                    createAppointment();
                }
            }, 2000);
        }
    });

</script>

<Section>
    <Loader delay={0} />
</Section>